import { withJobTrackingData } from "./withJobTrackingData";

interface BinCellProps {
  /** The bin to display */
  bin: {
    id: number;
    number: string;
  } | null;

  /** If true, the bin will be displayed as a warning if it is not the SO rack */
  warnForNonSORack?: boolean;
}

/**
 * Render a table cell with the bin number. If the bin is the sales order rack bin, it will be rendered with a subtle
 * text color so that non-expected bins are more visible. Non-expected bins can optionally be rendered with a warning icon.
 */
export const BinCell = withJobTrackingData<BinCellProps>(({ bin, salesOrderRackBin, warnForNonSORack }) => {
  if (!bin) return null;
  const isSORack = bin.id === salesOrderRackBin.id;
  const warnIcon = !isSORack && warnForNonSORack ? "⚠ " : "";
  const className =
    isSORack ? "text-secondary"
    : warnForNonSORack ? "text-warning"
    : undefined;
  return (
    <span className={className}>
      {warnIcon}
      {bin.number}
    </span>
  );
});
